import { Component } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-icon-button-cell-renderer-component',
  imports: [MatIconModule, MatButtonModule, MatTooltipModule, MatBadgeModule],
  templateUrl: './icon-button-cell-renderer-component.html'
})
export class IconButtonCellRendererComponent {
  params!: any;
  isDisabled: boolean = false;
  icon: string = '';

  visible: boolean = true;

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    if (this.params.disabled && typeof(this.params.disabled) === 'function') {
      this.isDisabled = this.params.disabled(this.params.data);
    } else {
      this.isDisabled = false;
    }

    if (this.params.icon && typeof(this.params.icon) === 'function') {
      this.icon = this.params.icon(this.params.data);
    } else {
      this.icon = this.params.icon || '';
    }

    if (this.params.tooltip && typeof(this.params.tooltip) === 'function') {
      this.params.tooltip = this.params.tooltip(this.params.data);
    } else {
      this.params.tooltip = this.params.tooltip || '';
    }

    if (this.params.badge && typeof(this.params.badge) === 'function') {
      this.params.badge = this.params.badge(this.params.data);
    }

    if (this.params.visible && typeof(this.params.visible) === 'function') {
      this.visible = this.params.visible(this.params.data);
    } else if (this.params.visible == false) {
      this.visible = false;
    }

    return true;
  }

  onClick() {
    if (this.params.onClick) {
      this.params.onClick(this.params.data, this.params.node.rowIndex);
    }
  }
}
